import type React from "react";

type Props = React.SVGProps<SVGSVGElement>;

const filterId = "filter0_d_import_payslip_icon";

const DragAndDropIcon: React.FC<Props> = ({
  width = 72,
  height = 72,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Drag and drop file"
    {...rest}
  >
    <title>Drag and drop file</title>
    <g filter={`url(#${filterId})`}>
      <path
        d="M68 10H52C29.9086 10 12 27.9086 12 50V66C12 88.0914 29.9086 106 52 106H68C90.0914 106 108 88.0914 108 66V50C108 27.9086 90.0914 10 68 10Z"
        fill="white"
      />
      <path
        d="M33 40C33 36.719 35.62 34 39 34H54V46C54 47.688 55.31 49 57 49H69V52.656C62.06 54.625 57 61 57 68.5C57 74.125 59.72 79 63.84 82C63.56 82 63.28 82 63 82H39C35.62 82 33 79.375 33 76V40ZM69 46H57V34L69 46ZM73.5 55C78.28 55 82.69 57.625 85.12 61.75C87.56 65.969 87.56 71.125 85.12 75.25C82.69 79.469 78.28 82 73.5 82C68.62 82 64.22 79.469 61.78 75.25C59.34 71.125 59.34 65.969 61.78 61.75C64.22 57.625 68.62 55 73.5 55ZM75 62.5C75 61.75 74.25 61 73.5 61C72.66 61 72 61.75 72 62.5V67H67.5C66.66 67 66 67.75 66 68.5C66 69.344 66.66 70 67.5 70H72V74.5C72 75.344 72.66 76 73.5 76C74.25 76 75 75.344 75 74.5V70H79.5C80.25 70 81 69.344 81 68.5C81 67.75 80.25 67 79.5 67H75V62.5Z"
        fill="#188A42"
      />
      <path
        opacity="0.4"
        d="M33 40C33 36.719 35.62 34 39 34H54V46C54 47.688 55.31 49 57 49H69V52.656C62.06 54.625 57 61 57 68.5C57 74.125 59.72 79 63.84 82C63.56 82 63.28 82 63 82H39C35.62 82 33 79.375 33 76V40ZM69 46H57V34L69 46ZM73.5 55C78.28 55 82.69 57.625 85.12 61.75C87.56 65.969 87.56 71.125 85.12 75.25C82.69 79.469 78.28 82 73.5 82C68.62 82 64.22 79.469 61.78 75.25C59.34 71.125 59.34 65.969 61.78 61.75C64.22 57.625 68.62 55 73.5 55ZM75 62.5C75 61.75 74.25 61 73.5 61C72.66 61 72 61.75 72 62.5V67H67.5C66.66 67 66 67.75 66 68.5C66 69.344 66.66 70 67.5 70H72V74.5C72 75.344 72.66 76 73.5 76C74.25 76 75 75.344 75 74.5V70H79.5C80.25 70 81 69.344 81 68.5C81 67.75 80.25 67 79.5 67H75V62.5Z"
        fill="#188A42"
      />
    </g>
    <defs>
      <filter
        id={filterId}
        x="0"
        y="0"
        width="120"
        height="120"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="6" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_1_395"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1_395"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default DragAndDropIcon;
